import * as Generated from '../../generated/graphql';
import {useProjectPageQuery} from '../../state/graphql/projectPageQuery';
import {useDispatch} from '../../state/hooks';
import {usePushReport} from '../../state/reports/hooks';
import * as ViewerHooks from '../../state/viewer/hooks';
import {useProjectParams} from './useProjectParams';

export function useProjectPageProps() {
  const {entityName, projectName} = useProjectParams();
  const viewer = ViewerHooks.useViewer();

  const projectQuery = useProjectPageQuery(
    {
      entityName,
      projectName,
    },
    {
      enablePolling: true,
    }
  );

  const [updateProject] = Generated.useUpsertModelMutation();

  const dispatch = useDispatch();

  const pushDraftReport = usePushReport(entityName, projectName);

  return {
    viewer,
    dispatch,
    updateProject,
    projectQuery,
    pushDraftReport,
  };
}
